module.exports = __webpack_public_path__ + "img/(1).47c5442b.jpg";